import React, { useContext, useEffect, useState } from "react";
import AppLayoutSecondaryHeader from "../layout/AppLayout/AppLayoutSecondaryHeader";
import PsContext from "../../context";
import { Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import { PsNoData } from "../../components";
import { Spin } from "antd";
import AddIcon from "@mui/icons-material/Add";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ModuleAccess from "../../context/moduleAccess";
import { IconButton, Switch } from "@mui/material";
import AddAgencyForm from "./addAgencyForm";
import {
  _DELETE_AGENCY,
  _LIST_AGENCIES,
  _UPDATE_STATUS,
} from "../../models/agenciesModel";
import { useDialog } from "../../context/DialogContext";
import EditAgencyForm from "./editAgencyForm";
import { upperCase } from "../../utils";
import AgencyUserLogins from "./agencyUserLogins";
import NewEditPartner from "./newEditPartner";
import PsOffCanvasWindow from "../../components/PsOffCanvasWindow";

const Agencies = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showLogins, setShowLogins] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [viewData, setViewData] = useState([]);

  const { openDialog } = useDialog();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _LIST_AGENCIES().then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
        setDataView(res.data);
      } else {
        setDataList([]);
        setDataView([]);
      }
      setLoader(false);
    });
  };

  const handleStatusChange = (item, sta, fieldName) => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Update ?",
      onConfirm: () => confirmUpdate(item, sta, fieldName),
    });
  };

  const confirmUpdate = (item, sta, fieldName) => {
    setLoader(true);
    _UPDATE_STATUS({
      id: item.id,
      field_value: sta == "1" ? "0" : "1",
      field_name: fieldName,
    }).then((res) => {
      if (res.status == "1") {
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
        setLoader(false);
      }
    });
  };

  const handleDeleteClick = (item) => {
    openDialog({
      title: "Confirm",
      message: `Do you want to Delete the Agency ${item.agent_name} ?`,
      onConfirm: () => confirmDelete(item),
    });
  };

  const confirmDelete = (item) => {
    setLoader(true);
    _DELETE_AGENCY({ id: item.id }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Deleted");
        loadData();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Delete",
        });
        setLoader(false);
      }
    });
  };

  const handleEdit = (item) => {
    setViewData(item);
    setEditModal(true);
  };

  const handleSearch = (e) => {
    let v = upperCase(e.target.value);
    let m = dataList.filter(
      (item) =>
        upperCase(item.agent_name).indexOf(v) > -1 ||
        upperCase(item.agent_mobile).indexOf(v) > -1,
    );
    setDataView(m);
  };

  const handleviewLoginsClick = (item) => {
    console.log(item);
    setViewData(item);
    setShowLogins(true);
  };

  return (
    <>
      <AppLayoutSecondaryHeader title="Partners">
        <ModuleAccess module="agent_mgt" action="action_create">
          <IconButton
            color="inherit"
            onClick={(e) => setAddModal(true)}
            title="Add Module"
          >
            <AddIcon />
          </IconButton>
        </ModuleAccess>
        <IconButton color="inherit" onClick={(e) => loadData()} title="Refresh">
          <AutorenewIcon />
        </IconButton>
      </AppLayoutSecondaryHeader>
      <div className="container mt-115">
        <Row className="mb-2">
          <Col md={12}>
            <InputGroup size="sm">
              <InputGroup.Text>
                <SearchIcon />
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="fw-bold"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </InputGroup>
          </Col>
        </Row>

        <Spin spinning={loader}>
          <div>
            <Table size="sm" hover>
              <thead>
                <tr className="fs-12">
                  <th width="60" className="text-center">
                    S.No
                  </th>
                  <th width="">Company Name</th>
                  <th width="100">Mobile</th>
                  <th width="">Email Id</th>
                  <th width="120" className="text-center">
                    Status
                  </th>
                  <th width="120" className="text-center">
                    Kalvisalai Name
                  </th>
                  <th width="120" className="text-center">
                    #
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataView.map((item, i) => {
                  return (
                    <tr key={i} className="fs-12 valign-middle">
                      <td align="center">{i + 1}</td>
                      <td className="fw-bold">
                        {item.website && item.website.length > 4 ? (
                          <a href={item.website} target="_blank">
                            {item.company_name}
                          </a>
                        ) : (
                          <span>{item.company_name}</span>
                        )}
                      </td>
                      <td>{item.mobile_no}</td>
                      <td>{item.email}</td>
                      <td align="center">
                        <Switch
                          size="small"
                          checked={item.active_status == "1" ? true : false}
                          onChange={(e) =>
                            handleStatusChange(
                              item,
                              item.active_status,
                              "active_status",
                            )
                          }
                        />
                      </td>
                      <td align="center">
                        <Switch
                          size="small"
                          checked={item.is_view_brandname == "1" ? true : false}
                          onChange={(e) =>
                            handleStatusChange(
                              item,
                              item.is_view_brandname,
                              "is_view_brandname",
                            )
                          }
                        />
                      </td>
                      <td align="center">
                        <ModuleAccess module="agnet_users" action="action_list">
                          <IconButton
                            title="User Logins"
                            onClick={(e) => handleviewLoginsClick(item)}
                          >
                            <PeopleAltIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                        <ModuleAccess module="agent_mgt" action="action_update">
                          <IconButton
                            title="Edit"
                            onClick={(e) => handleEdit(item)}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                        <ModuleAccess module="agent_mgt" action="action_delete">
                          <IconButton
                            title="Delete"
                            onClick={(e) => handleDeleteClick(item)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </ModuleAccess>
                      </td>
                    </tr>
                  );
                })}
                {dataList.length < 1 && !loader && (
                  <tr>
                    <td colSpan={6}>
                      <PsNoData withHeight />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Spin>
      </div>

      <AddAgencyForm
        show={addModal}
        onHide={(e) => setAddModal(false)}
        onSuccess={() => {
          setAddModal(false);
          loadData();
        }}
      />

      {/*     <EditAgencyForm
        show={editModal}
        dataSource={viewData}
        onHide={(e) => {
          setEditModal(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setEditModal(false);
          setViewData([]);
          loadData();
        }}
      /> */}

      <PsOffCanvasWindow
        title={"Partner Management"}
        onHide={(e) => {
          setEditModal(false);

          setViewData([]);
          loadData();
        }}
        show={editModal}
        size="lg"
      >
        {editModal && <NewEditPartner dataSource={viewData} />}
      </PsOffCanvasWindow>

      <AgencyUserLogins
        show={showLogins}
        dataSource={viewData}
        onHide={(e) => {
          setShowLogins(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setShowLogins(false);
          setViewData([]);
          loadData();
        }}
      />
    </>
  );
};
export default Agencies;
